export function menuBlogSlider() {
    let $blogSlider = $(".menu-blog-slider");
    let $win = $(window);
    let initSliderFunc = function() {
        $blogSlider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            infinite: false,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: "unslick"
                }
            ]
        });
    };

    if ($win.width() < 1200) {
        initSliderFunc();
    }

    $win.on("resize", function() {

        if ($win.width() < 1200 && !$blogSlider.hasClass("slick-initialized")) {
            initSliderFunc();
        }
    });
};


// WEBPACK FOOTER //
// ./assets/js/modules/menuBlogSlider.js